import { render, staticRenderFns } from "./WpInstallPanel.vue?vue&type=template&id=00ba96e5&scoped=true&"
import script from "./WpInstallPanel.vue?vue&type=script&lang=ts&"
export * from "./WpInstallPanel.vue?vue&type=script&lang=ts&"
import style0 from "./WpInstallPanel.vue?vue&type=style&index=0&id=00ba96e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba96e5",
  null
  
)

export default component.exports